// One address for the app, so the session cookie can be first-party.
//
// The same app answers on three hostnames (the Firebase defaults and
// app.kintsuba.ai, which is already the address the backend puts in password
// reset mails). That was harmless while the cookie was cross-site to all of
// them — it is not harmless once the API moves to api.kintsuba.ai: a cookie
// set there is first-party for a page on app.kintsuba.ai and third-party for
// the same page served from *.web.app, and Safari (and Chrome with tracking
// protection on) drops the third-party one. Someone who reached the app by
// its old address would keep being thrown back to the login screen by every
// reload while everyone else was fine, which is the worst kind of bug to be
// told about.
//
// So the old addresses send you to the canonical one, keeping the path, the
// query and the hash, with `replace` so Back does not bounce.
const CANONICAL_HOST = 'app.kintsuba.ai'
const LEGACY_HOSTS = ['spread-agent.web.app', 'spread-agent.firebaseapp.com']

export const redirectToCanonicalHost = (): void => {
  if (typeof window === 'undefined') return
  if (!LEGACY_HOSTS.includes(window.location.hostname)) return
  const url = new URL(window.location.href)
  url.hostname = CANONICAL_HOST
  window.location.replace(url.toString())
}
